import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import {NETWORK_RESERVATION_DETAIL_SHORT} from '../../../constants/appUrls.constants';
import {
    countNights,
    formatAmount,
    formatShortDate,
    getGuestInitials,
    resolveBookingStatus,
} from './bookingNotificationHelpers';

/**
 * Tek rezervasyon satiri.
 *
 * `guest.full_name` NULL gelebilir (iletisim kaydi yoksa) — karsilaniyor.
 * Otel adi bilerek gosterilmiyor: kapsam hep tek tesis oldugu icin her satirda
 * ayni ada tekrar etmis oluruz, ustelik baslikta zaten yaziyor.
 */
export default function BookingNotificationItem(props) {

    const {booking, isNew, onNavigate} = props;
    const {t, i18n} = useTranslation();

    const guestName = booking && booking.guest ? booking.guest.full_name : null;

    const status = resolveBookingStatus(booking.status, t);
    const amount = formatAmount(booking.total, i18n.language);
    const checkin = formatShortDate(booking.checkin_date);
    const checkout = formatShortDate(booking.checkout_date);
    const nights = countNights(booking.checkin_date, booking.checkout_date);

    const displayName = guestName || t('enw-booking_notification-guest_unknown', 'Misafir adı belirtilmemiş');

    return (
        <Link
            to={NETWORK_RESERVATION_DETAIL_SHORT + booking.id}
            className={`bkn-item${isNew ? ' is-new' : ''}`}
            onClick={onNavigate}
        >
            <span className="bkn-item__avatar" aria-hidden="true">
                {getGuestInitials(guestName)}
            </span>

            <span className="bkn-item__body">
                <span className="bkn-item__top">
                    <span className="bkn-item__name" title={displayName}>{displayName}</span>
                    {
                        amount !== null &&
                        <span className="bkn-item__amount">
                            {amount}
                            <span className="bkn-item__currency">{booking.currency_code}</span>
                        </span>
                    }
                </span>

                {
                    booking.booking_code &&
                    <span className="bkn-item__code">{booking.booking_code}</span>
                }

                <span className="bkn-item__footer">
                    {
                        (checkin || checkout) &&
                        <span className="bkn-item__dates">
                            <i className="fal fa-calendar-alt" />
                            {checkin || '—'}
                            <i className="fas fa-long-arrow-right bkn-item__arrow" />
                            {checkout || '—'}
                            {
                                nights > 0 &&
                                <span className="bkn-item__nights">
                                    {/* `count` i18next'in cogul mekanizmasini tetikler:
                                        EN'de "1 night" / "2 nights" ayrimi icin `_plural`
                                        anahtari kullanilir, TR'de ikisi de ayni metindir. */}
                                    {t('enw-booking_notification-nights', {defaultValue: '{{count}} gece', count: nights})}
                                </span>
                            }
                        </span>
                    }
                    {
                        status &&
                        <span className={`bkn-pill bkn-pill--${status.tone}`}>{status.label}</span>
                    }
                </span>
            </span>

            <i className="fas fa-chevron-right bkn-item__chevron" aria-hidden="true" />
        </Link>
    );
}
